<script>
  import instagram from '$lib/assets/img/footer/instagram.svg';
  import facebook from '$lib/assets/img/footer/facebook.svg';
  import linkedin from '$lib/assets/img/footer/linkedin.svg';
  import x from '$lib/assets/img/footer/x.svg';

  /** @type number */
  let currentYear = new Date().getFullYear();

  /** @type string */
  let copyright = `Copyright © 2019 - ${currentYear} impulso.space`;
</script>

<footer class="mt-auto">
  <div class="container-fluid border-top">
    <div class="container mt-5">
      <div class="row justify-content-center mb-4">
        <div class="col-auto ps-2 pe-2">
          <a class="social-link" href="https://twitter.com/ImpulsoSpace" target="_blank">
            <img src={x} alt="impulso.space X account" />
          </a>
        </div>

        <div class="col-auto ps-2 pe-2">
          <a
            class="social-link"
            href="https://www.facebook.com/Impulsospace-105806628551637/"
            target="_blank"
          >
            <img src={facebook} alt="impulso.space Facebook account" />
          </a>
        </div>

        <div class="col-auto ps-2 pe-2">
          <a class="social-link" href="https://www.instagram.com/impulso.space/" target="_blank">
            <img src={instagram} alt="impulso.space Instagram account" />
          </a>
        </div>

        <div class="col-auto ps-2 pe-2">
          <a
            class="social-link"
            href="https://www.linkedin.com/company/impulso-space/"
            target="_blank"
          >
            <img src={linkedin} alt="impulso.space Linkedin account" />
          </a>
        </div>
      </div>

      <div class="row justify-content-center mt-4 border-top">
        <div class="col text-center my-4">
          <span>{copyright}</span>

          <span class="ms-1 me-1">·</span>
          <a href="/privacyPolicy">Privacy Policy</a>

          <span class="ms-1 me-1">·</span>
          <a href="/sitemap">Sitemap</a>
        </div>
      </div>
    </div>
  </div>
</footer>

<style>
  .container-fluid {
    background-color: var(--grey-06);
  }

  .social-link img {
    width: 30px;
    height: 30px;
  }

  a:hover {
    opacity: 0.7;
  }
</style>
